import { DEFAULT_ATTRIBUTES_SWR_CONFIG } from "shared/api/constants";
import { useAPI } from "shared/api/hooks";

import { AllAttributesResponse, listAttributesRequestURI } from "./api";

export const useAllAttributes = () =>
  useAPI<null, AllAttributesResponse>(
    listAttributesRequestURI,
    null,
    DEFAULT_ATTRIBUTES_SWR_CONFIG
  );
